import { AssessmentType } from './enums'
import { AssessmentData } from './types'

function checkFirstResponseIfNeeded(assessmentItem: AssessmentData) {
  if (assessmentItem.type === AssessmentType.MULTI) return

  if (
    assessmentItem.autoSelectFirstChoice &&
    !assessmentItem.responses.some(resp => resp.checked) &&
    assessmentItem.checked
  ) {
    if (assessmentItem.responses[0]) {
      assessmentItem.responses[0].checked = true
    }
  }

  // If an assessment in the collapsed state then every its response must be unselected
  if (!assessmentItem.checked) {
    assessmentItem.responses.forEach(resp => {
      resp.checked = false
    })
  }
}

export default checkFirstResponseIfNeeded
